import React from 'react'
import PropTypes from 'prop-types'
import { formatSingleNumber } from '../utils'

class CountDown extends React.Component {

  static propTypes = {
    deadTime: PropTypes.number,
    callback: PropTypes.func.isRequired,
  }

  static defaultProps = {
    deadTime: new Date().getTime(),
  }

  constructor(props) {
    super(props)
    this.state = {
      timeNow: new Date().getTime(),
    }
    this.timer = null
  }

  componentDidMount() {
    // 为了避免服务端和客户端渲染的不一致，只能在 didmount 后来做初始化了
    this.setState({
      timeNow: new Date().getTime(),
    })
    this.timer = setInterval(this.countDown, 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.timer)
    this.timer = null
  }

  secondsToTime = () => {
    let secs = this.props.deadTime - this.state.timeNow
    secs = Math.floor(secs / 1000)
    const day = Math.floor(secs / (60 * 60 * 24))
    const divisorForHours = secs % (60 * 60 * 24)
    const hours = Math.floor(divisorForHours / (60 * 60))
    const divisorForMinutes = secs % (60 * 60)
    const minutes = Math.floor(divisorForMinutes / 60)

    const divisorForSeconds = divisorForMinutes % 60
    const seconds = Math.ceil(divisorForSeconds)

    const formatTime = `${formatSingleNumber(hours)}:${formatSingleNumber(minutes)}:${formatSingleNumber(seconds)}`
    if (day > 0) return `${day}天${formatTime}`
    return formatTime
  }

  countDown = () => {
    const { callback, deadTime } = this.props
    if (deadTime > new Date().getTime()) {
      this.setState({
        timeNow: new Date().getTime(),
      })
    } else {
      clearInterval(this.timer)
      callback()
    }
  }

  render() {
    return (
      <span>{this.secondsToTime()}</span>
    )
  }
}

export default CountDown



// WEBPACK FOOTER //
// ./src/components/common/CountDown/index.js